// extracted by mini-css-extract-plugin
module.exports = {"holder":"CustomError_holder__HmxLS","errorCode":"CustomError_errorCode__O5azE","errorMsg":"CustomError_errorMsg__WKbXx"};